import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { CloseIcon } from "../../../assets/icons";
import { handleKeyDown } from "../../../utils/OtherFunctions";
import { NuInput } from "../../../utils/Inputs";
import { CancelButton, SubmitButton } from "../../../utils/Button";
import useAddData from "../../../hooks/useAddData";
import useEditData from "../../../hooks/useEditData";

export default function CreateorUpdate({
  data,
  visible,
  onClose,
  refreshData,
}) {
  const { isCreateLoading, addData } = useAddData();
  const { isEditLoading, editData } = useEditData();
  const [roleInfo, setRoleInfo] = useState([]);
  const [createNew, setCreateNew] = useState({
    role: "",
    permissions: [],
  });

  useEffect(() => {
    setCreateNew({
        ...createNew,
      role:data?.roleName,
    });
    setRoleInfo(data?.permissions||[])
  }, [data]);

  const userRole = [
    {
      name: "Information",
      roles: [
        {
          id: 1,
          name: "View",
        },
        {
          id: 2,
          name: "Create",
        },
        {
          id: 3,
          name: "Edit",
        },
        {
          id: 4,
          name: "Delete",
        },
      ],
    },
    {
      name: "Activity",
      roles: [
        {
          id: 5,
          name: "View",
        },
        {
          id: 6,
          name: "Create",
        },
        {
          id: 7,
          name: "Edit",
        },
        {
          id: 8,
          name: "Delete",
        },
      ],
    },
    {
      name: "Reference Docs",
      roles: [
        {
          id: 9,
          name: "View",
        },
        {
          id: 10,
          name: "Create",
        },
        {
          id: 11,
          name: "Edit",
        },
        {
          id: 12,
          name: "Delete",
        },
      ],
    },
    {
      name: "Report",
      roles: [
        {
          id: 13,
          name: "View",
        },
      ],
    },
    {
      name: "Admin/Settings",
      roles: [
        {
          id: 14,
          name: "View",
        },
        {
          id: 15,
          name: "Create",
        },
        {
          id: 16,
          name: "Edit",
        },
        {
          id: 17,
          name: "Delete",
        },
      ],
    },
    {
      name: "Review & Approve",
      roles: [
        {
          id: 18,
          name: "Permission",
        },
      ],
    },
    {
      name: "Standard Reset",
      roles: [
        {
          id: 19,
          name: "Permission",
        },
      ],
    },
    {
      name: "Backup Delete",
      roles: [
        {
          id: 20,
          name: "Permission",
        },
      ],
    },
    {
      name: "Import / Export Files",
      roles: [
        {
          id: 25,
          name: "import",
        },
        {
          id: 26,
          name: "export",
        }
      ]
    }
  ];

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (value, { resetForm }) => {
      value.permissions = roleInfo;
      if (data?.roleId) {
        editData({
            url: `/Role-Permission/multi-update`,
            value: value,
            resetForm: resetForm,
            onClose: onClose,
            getData: refreshData,
          });
      } else {
        addData({
            url: "/Role-Permission/add",
            value: value,
            resetForm: resetForm,
            onClose: onClose,
            getData: refreshData,
          });
      }
    },
  });

  const selectRow = (name, id) => {
    let testUser;
    if (roleInfo && roleInfo.some((Userid) => Userid === id)) {
      testUser = roleInfo.filter((roleId) => roleId !== id);
      setRoleInfo(testUser);
    } else {
      setRoleInfo([...roleInfo, id]);
    }
  };

  const resetClose = ()=>{
    formik.resetForm()
    onClose()
  }

  if (!visible) return null;

  return (
    <>
      <div
        id="modal"
        // onClick={handleOnClose}
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center "
      >
        <div className="bg-white mt-12 p-2 rounded-xl w-6/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
              {data ? "Edit" : "New"}
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={onClose}
            >
              <CloseIcon />
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className="relative px-6 max-h-[calc(100vh-180px)] text-left flex  flex-wrap justify-between overflow-y-auto">
              <div className=" w-full">
                <NuInput
                  label="Role Name"
                  disabled={data ? true : false}
                  name="role"
                  formik={formik}
                  placeholder="Role Name"
                />
              </div>
              <div className=" w-full">
                {userRole.map((item, index) => {
                  return (
                    <div key={index}>
                      <p className=" my-2 px-4 font-semibold text-[13px] 2xl:text-[15px]">{item?.name}</p>
                      <div className=" grid grid-cols-4 gap-2 px-6">
                        {item.roles.map((role, index) => {
                          return (
                            <div key={index} className=" w-full text-left text-xs 2xl:text-sm flex items-center">
                              <input
                                type="checkbox"
                                className="px-3 mr-2 py-2 accent-main-blue"
                                checked={roleInfo.some((id) => id === role.id)}
                                onChange={() => selectRow(item.name, role.id)}
                              />
                              <span>{role.name}</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className=" w-full flex items-center justify-end px-6 py-6 rounded-b text-xs 2xl:text-sm">
                <CancelButton onClose={resetClose} isLoading={isCreateLoading||isEditLoading} />
                <SubmitButton isLoading={isCreateLoading||isEditLoading} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
